<template>
    <div>
        <rkm-data-table
            :request-params="requestParams"
            :fields="fields"
            :filter="filter"
            :repository="repositories.aprovacaoEntrada"
            :searchBy="searchBy"
            ref="RkmDataTable"
            sort-by="dataDocumento"
        >
            <template
                v-if="model"
                v-slot:filters
            >
                <rkm-form ref="RkmForm">
                    <rkm-row>
                        <rkm-col cols="5">
                            <rkm-form-date-picker
                                :end-validations="validations.periodo"
                                :max-date="additionals.dataAtual"
                                :range-inline="false"
                                :start-validations="validations.periodo"
                                end-label="Até"
                                range
                                start-label="Período de"
                                v-model="model.periodo"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-input
                                :label="false"
                                @keyup.native.enter="handleEnterKey"
                                placeholder="Digite para buscar"
                                v-model="filter"
                            >
                                <rkm-input-group-prepend slot="prepend">
                                    <rkm-form-select
                                        :options="searchOptions"
                                        class="m-0"
                                        v-model="searchBy"
                                    />
                                </rkm-input-group-prepend>

                                <rkm-input-group-append slot="append">
                                    <rkm-button
                                        @click="$refs.RkmForm.validate($refs.RkmDataTable.search)"
                                        color="primary"
                                        class="btn-search"
                                    >
                                        Buscar
                                    </rkm-button>
                                    <rkm-button
                                        :disabled="!model.periodo.start && !model.periodo.end && !filter"
                                        @click="clear"
                                        class="btn-clear"
                                    >
                                        Limpar
                                    </rkm-button>
                                </rkm-input-group-append>
                            </rkm-form-input>
                        </rkm-col>
                    </rkm-row>
                </rkm-form>
            </template>

            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    @click="$refs.ModalEntrada.open(item.id)"
                    authorize="edit-web-service-almoxarifado-cliente-aprovacao-entrada"
                    color="primary"
                    small
                    title="Visualizar"
                >
                    <rkm-icon icon="eye" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <ModalEntrada
            @saved="$refs.RkmDataTable.refresh()"
            ref="ModalEntrada"
        />
    </div>
</template>

<script>
// Components.
import ModalEntrada from './components/entrada/Modal'

// Mixins.
import {error, repository} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

// Moment.
import moment from 'moment'

export default {
    components: {ModalEntrada},
    computed: {
        validations() {
            return {
                periodo: {required: true},
            }
        },
        searchOptions() {
            return this.fields.filter(field => !!field.searchable && field.key !== 'dataDocumento').map(field => {
                return { text: field.label, value: field.key }
            })
        },
        requestParams() {
            return {
                periodo: {
                    start: this.model && this.model.periodo.start ? moment(this.model.periodo.start).format('YYYY-MM-DD') : null,
                    end: this.model && this.model.periodo.end ? moment(this.model.periodo.end).format('YYYY-MM-DD') : null,
                },
            }
        }
    },
    created() {
        this.repositories = {
            aprovacaoEntrada: this.getConectaSusRepository('webService.almoxarifado.cliente.aprovacaoEntrada'),
        }

        this.load()
    },
    data: () => ({
        additionals: null,
        model: null,
        fields: [
            {key: 'unidadeNome', label: 'Almoxarifado', name: 'unidade.nome', searchable: true, sortable: true},
            {key: 'fornecedorNome', label: 'Fornecedor', name: 'fornecedor.nome', searchable: true, sortable: true},
            {key: 'codigoNota', label: 'Código da nota', name: 'entrada.codigoNota', searchable: true, sortable: true},
            {key: 'documentoTipoNome', label: 'Tipo de documento', name: 'documentoTipo.nome', searchable: true, sortable: true},
            {key: 'dataDocumento', label: 'Data do documento', name: 'entrada.dataDocumento', searchable: true, sortable: true},
            {key: 'numeroDocumento', label: 'Número do documento', name: 'entrada.numeroDocumento', searchable: true, sortable: true},
            {key: 'numeroPedido', label: 'Número do pedido', name: 'entrada.numeroPedido', searchable: true, sortable: true},
            {key: 'statusNome', label: 'Status', name: 'status.nome', searchable: true, sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
        searchBy: 'unidadeNome',
        filter: null,
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.aprovacaoEntrada.list()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEnterKey(event) {

            if (event.key === 'Enter' && this.filter) {
                this.$refs.RkmDataTable.search();
            }
        },
        clear() {
            this.model.periodo = {start: null, end: null}
            this.searchBy = 'unidadeNome'
            this.filter = null

            this.$refs.RkmDataTable.clearTable()
        },
    },
    mixins: [error, repository],
    watch: {
        'model.periodo': {
            deep: true,
            handler() {
                this.$refs.RkmDataTable.clearTable()
            }
        },
        'filter'() {
            this.$refs.RkmDataTable.clearTable()
        }
    }
}
</script>

<style scoped>
.btn-search {
    border-top-right-radius: 0.25rem!important;
    border-bottom-right-radius: 0.25rem!important;
}
.btn-clear {
    border-top-left-radius: 0.25rem!important;
    border-bottom-left-radius: 0.25rem!important;
}
</style>